const TRAIL_ACTION = Object.freeze({
  PUSH: 'trail/PUSH',
  GO_BACK: 'trail/GO_BACK',
});

export default TRAIL_ACTION;
